var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<admin-nav-bar selected=\"Dashboard\"></admin-nav-bar>\n<div layout=\"row\" layout-align=\"start start\" layout-fill>\n<dashboard-grid style=\"display:block; min-width:500px; width:40%;\" user-selected=\"vm.userSelected(profile)\">\n</dashboard-grid>\n<dashboard-details style=\"display:block; min-width:650px; width:60%\">\n</dashboard-details>\n</div>";
var id1="admin/dashboard/dashboard.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/components/admin/dashboard/dashboard.html
// module id = 613
// module chunks = 0